// InterviewCallLetter.jsx (the post-login wizard's Interview Call Letter step). The printable letter
// payload (#outerBorder/#divReceiptPrint, captured by html2canvas/jspdf in onPrint, including the
// admin-authored dangerouslySetInnerHTML letter body itself) is deliberately left untouched — same
// established precedent as preview.js/challanDetails.js/examCard.js/receiptDetails.js. Only the page
// chrome OUTSIDE the printable payload (page heading, Back/Print action buttons) is migrated here — a
// Phase C.5 (Candidate System UI Language Migration) addition; all 3 entries were already bilingual in
// the file (extractions, zero new translation authored).
export default {
  pageHeading: { en: 'Interview Call Letter', mr: 'मुलाखतीचे कॉल लेटर' },
  backButton: { en: 'Back', mr: 'मागे जा' },
  printDownloadButton: {
    en: 'Print / Download Interview Call Letter',
    mr: 'मुलाखतीचे कॉल लेटर प्रिंट / डाउनलोड करा'
  }
};
